import PropTypes from 'prop-types';
import WarrantySelectEnhanced from './WarrantySelectEnhanced';

const WarrantySelect = (props) => {
  return <WarrantySelectEnhanced {...props} />;
};

WarrantySelect.propTypes = {
  appCtx: PropTypes.object.isRequired,
};

export { WarrantySelect };
